/*
 * @Descripttion: 对G6的封装
 * @Author: yang chenglin
 */
import G6 from '@antv/g6';
import Moment from 'moment';
import { event } from '@ice/stark-data';
import rightArrowIcon from '@/assets/images/CanvasImages/rightArrow.png'; //右箭头icon
import checkSignIcon from '@/assets/images/CanvasImages/checkSign.png'; //对号实心icon
import exclamatoryMarkIcon from '@/assets/images/CanvasImages/exclamatoryMark.png'; //感叹号空心icon
import UUID from '@/utils/UUID';

// 节点展示label信息的文案名称
const nodeContentTitleSource = {
    "node-CROWD_DIG-2": '请选择人群',
    'node-MARKETING_SMS-2': '短信内容：',
    'node-MARKETING_RICH_SMS-2': '富信内容：',
    'node-MARKETING_RICH_TEXT_SMS-2': '富信内容：',
    'node-MARKETING_COUPON-2': '优惠券：',
    'node-MARKETING_MSG_BOX-2': '消息内容：',
    'node-MARKETING_PACKAGE_ANALYSIS-2': '分析维度：',
    'node-MARKETING_CROWD_BEHAVIOR_ANALYSIS-2': '',
    'node-MARKETING_DONGDONG-2': '消息内容：',
};
// 过滤需要展示复杂label信息的节点的内容
const nodeContentFilter = {
    'CROWD_DIG': (node) => (!node.data || node.data.crowdId === '') ? false : node.data.crowdId,
    'MARKETING_SMS': (node) => (!node.data || node.data.smsContent === '') ? false : node.data.smsContent,
    'MARKETING_RICH_SMS': (node) => (!node.data || node.data.detail[1].content === '') ? false : node.data.detail[1].content,
    'MARKETING_RICH_TEXT_SMS': (node) => (!node.data || node.data.templateId === '') ? false : node.data.templateId,
    'MARKETING_COUPON': (node) => (!node.data || node.data.couponRecordId === '') ? false : node.data.couponRecordId,
    'MARKETING_MSG_BOX': (node) => (!node.data || node.data.textContent === '') ? false : node.data.textContent,
    'MARKETING_PACKAGE_ANALYSIS': (node) => (!node.data || node.data.analysisDimension.length === 0) ? false : node.data.analysisDimension,
    'MARKETING_CROWD_BEHAVIOR_ANALYSIS': (node) => true,
    'MARKETING_DONGDONG': (node) => (!node.data || node.data.tplData === '') ? false : node.data.tplData,
};

// 节点展示时间信息的文案名称
const nodeTimeTitleSource = {
    'node-MARKETING_SMS-2': '发送时间：',
    'node-MARKETING_RICH_SMS-2': '发送时间：',
    'node-MARKETING_RICH_TEXT_SMS-2': '发送时间：',
    'node-MARKETING_COUPON-2': '投放时间：',
    'node-MARKETING_MSG_BOX-2': '投放/过期时间：',
    'node-MARKETING_CROWD_BEHAVIOR_ANALYSIS-2': '分析时间：',
    'node-MARKETING_DONGDONG-2': '发送时间：'
};
// 需要展示时间的节点及计算时间是什么的方法
const nodeTimeFilter = {
    'MARKETING_SMS': (node) => (!node.data || node.data.executionTime === '') ? false : node.data.cycleType === 1 ? (node.data.executionTime ? Moment(node.data.executionTime).format('YYYY-MM-DD HH:mm:ss') : 0) : `${Math.floor((node.data.executionTime - node.data.executionMinute * 60000) / 3600000)}:${node.data.executionMinute}`,
    'MARKETING_RICH_SMS': (node) => (!node.data || node.data.executionTime === '') ? false : Moment(node.data.executionTime).format('YYYY-MM-DD HH:mm:ss'),
    'MARKETING_RICH_TEXT_SMS': (node) => (!node.data || node.data.executionTime === '') ? false : node.data.timeSendingSwitch === 0 ? 0 : (node.data.executionTime ? Moment(node.data.executionTime).format('YYYY-MM-DD HH:mm:ss') : false),
    'MARKETING_COUPON': (node) => (!node.data || node.data.executionTime === '') ? false : node.data.cycleType === 1 ? Moment(node.data.startTime).format('YYYY-MM-DD HH:mm:ss') : Moment(node.data.executionTime).format('YYYY-MM-DD HH:mm:ss'),
    'MARKETING_MSG_BOX': (node) => (!node.data || node.data.executionTime === '') ? false : [Moment(node.data.executionTime).format('YYYY-MM-DD HH:mm:ss'), Moment(node.data.invalidTime).format('YYYY-MM-DD HH:mm:ss')],
    'MARKETING_CROWD_BEHAVIOR_ANALYSIS': (node) => (!node.data || node.data.executionTime === '') ? false : Moment(node.data.startTime).format('YYYY-MM-DD HH:mm:ss'),
    'MARKETING_DONGDONG': (node) => (!node.data || node.data.executionTime === '') ? false : Moment(+node.data.executionTime).format('YYYY-MM-DD HH:mm:ss'),
}

// label需要放在节点下方的操作类型节点
const labelPositionFilter = ['node-CROWD_UNION-2', 'node-CROWD_INTERSECTION-2', 'node-CROWD_DIFFERENCE-2', 'node-CROWD_DIFFERENCES-2', 'node-CROWD_PRESERVATION-2', 'node-CROWD_EXTRACT-2', 'node-CROWD_SPLIT-2', 'node-BATCH_SMS-2', 'node-CROWD_INTERSECTION_2-2', 'node-CROWD_UNION_2-2'];

// 无需连接后置节点的操作类型节点
const noPostNodeFilter = ['node-MARKETING_COUPON-2', 'node-MARKETING_PACKAGE_ANALYSIS-2', 'node-MARKETING_CROWD_BEHAVIOR_ANALYSIS-2', 'node-MARKETING_RICH_SMS-2', 'node-MARKETING_RICH_TEXT_SMS-2', 'node-MARKETING_MSG_BOX-2', 'node-MARKETING_DONGDONG-2'];

// 无需展示运行人群数的操作类型节点
const noRunCrowdFilter = ['node-CROWD_DIFFERENCE-2', 'node-BATCH_SMS-2', 'node-CROWD_INTERSECTION_2-2', 'node-CROWD_UNION_2-2'];

// 排除、抽取节点需要展示目标人群
const targetCrowdFilter = ['node-CROWD_EXTRACT-2'];  // 'node-CROWD_DIFFERENCE-2',

// 过滤需要展示复杂label信息的节点的内容
const nodeTargetCrowdFilter = {
    'CROWD_DIFFERENCE': (node) => (!node.data || node.data.crowdName === '') ? false : node.data.crowdName,
    'CROWD_EXTRACT': (node) => (!node.data || node.data.extractType === '') ? false : (typeof node.data.extractType) === 'number' ? ['全部', '发送成功', '发送失败'][node.data.extractType - 1] : node.data.extractType,
}

// 预执行或真正执行时，节点下方的人群数label文字
const previewNodeLabel = {
    "node-CROWD_DIG-2": {
        'preview': '预估人群数',
        'detail': '运行人群数'
    },
    'node-MARKETING_SMS-2': {
        'preview': '预计发送人数',
        'detail': '预计发送人数'
    },
    'node-MARKETING_RICH_SMS-2': {
        'preview': '预计发送人数',
        'detail': '预计发送人数'
    },
    'node-MARKETING_RICH_TEXT_SMS-2': {
        'preview': '预计发送人数',
        'detail': '预计发送人数'
    },
    'node-MARKETING_COUPON-2': {
        'preview': '预计发送人数',
        'detail': '预计发送人数'
    },
    'node-MARKETING_MSG_BOX-2': {
        'preview': '预计发送人数',
        'detail': '预计发送人数'
    },
    'node-MARKETING_PACKAGE_ANALYSIS-2': {
        'preview': '预估人群数',
        'detail': '运行人群数'
    },
    "node-MARKETING_CROWD_BEHAVIOR_ANALYSIS-2": {
        'preview': '预估人群数',
        'detail': '运行人群数'
    },
    "node-MARKETING_DONGDONG-2": {
        'preview': '预计发送人数',
        'detail': '预计发送人数'
    },
}


// 节点的各个形状的name，用常量记录一下
const CIRCLE_SHAPE_NAME = 'circle-shape';
const CIRCLE_ICON_NAME = 'circle-icon';
const RIGHT_ANCHOR_NAME = 'circle-right-anchor';
const LEFT_ANCHOR_NAME = 'circle-left-anchor';
const FOCUS_MARK_NAME = 'circle-focus-rect';
const SUCCESS_MARK_NAME = 'success_marker';
const EORROR_MARKER_NAME = 'error_marker';
const TO_LINK = 'toLink';
const TO_NOT_LINK = 'toNotLink';

// 注册自定义的边线
G6.registerEdge('lz-edge', {
    draw(cfg, group) {
        const startPoint = cfg.startPoint;
        const endPoint = cfg.endPoint;
        // 主要的线条
        const keyShape = group.addShape('path', {
            attrs: {
                stroke: '#65717F',
                path: [
                    ['M', startPoint.x, startPoint.y], // 移动到出发点
                    ['L', startPoint.x + 15, startPoint.y], // 向右划线15
                    ['L', endPoint.x - 25, endPoint.y], // 划线到结束位置左侧25，多了10是箭头的长度
                    ['L', endPoint.x, endPoint.y] // 划线到结束位置
                ],
                lineJoin: 'bevel',
                cursor: 'pointer',
            },
            name: 'lz-edge-line'
        });
        // 连线上新增文字【提供给去重节点的优先级】
        // const textShape = group.addShape('text', {
        //     attrs: {
        //         text: cfg.label,
        //         stroke: '#65717F',
        //         x: (startPoint.x + endPoint.x) * 0.5,
        //         y: endPoint.y - 4,
        //         fontSize: 12,
        //         textAlign: 'center',
        //         fill: 'red',
        //         textBaseline: 'center',
        //     },
        // });
        // 为方便选中线，扩展一下线的可选中位置，不然只有一个px的线是在太难选中了
        const bgBoldLine = group.addShape('path', {
            attrs: {
                stroke: 'transparent',
                lineWidth: 10,
                path: [
                    ['M', startPoint.x, startPoint.y], // 移动到出发点
                    ['L', startPoint.x + 15, startPoint.y], // 向右划线15
                    ['L', endPoint.x - 25, endPoint.y], // 划线到结束位置左侧25，多了10是箭头的长度
                    ['L', endPoint.x, endPoint.y] // 划线到结束位置
                ],
                opacity: 1,
                cursor: 'pointer'
            },
            name: 'lz-edge-bg'
        });

        // 结尾处的箭头
        const endArrow = group?.addShape('polygon', {
            attrs: {
                points: [
                    [endPoint.x, endPoint.y],
                    [endPoint.x - 10, endPoint.y + 4],
                    [endPoint.x - 10, endPoint.y - 4]
                ],
                fill: '#65717F'
            },
            name: 'end-arrow'
        });

        // 用于展示线选中状态的蓝色边框
        const lineRect = group.addShape('path', {
            attrs: {
                stroke: '#3399FF',
                endArrow: {
                    // 自定义箭头指向(0, 0)，尾部朝向 x 轴正方向的 path
                    path: 'M 0,0 L 10,5 L 10,-5 Z',
                    // 箭头的偏移量，负值代表向 x 轴正方向移动
                    // d: -10,
                    fill: '#3399FF'
                },
                lineWeidth: 10,
                path: [
                    ['M', startPoint.x, startPoint.y], // 移动到出发点
                    ['L', startPoint.x + 15, startPoint.y], // 向右划线15
                    ['L', endPoint.x - 25, endPoint.y], // 划线到结束位置左侧25，多了10是箭头的长度
                    ['L', endPoint.x, endPoint.y] // 划线到结束位置
                ],
                opacity: 0
            },
            name: 'line-Rect'
        });
        return keyShape;
    },
    setState(name, value, item) {
        const group = item!.getContainer();
        if (name === 'focus' || name === 'selected') {
            // TODO:这种按照序号获取的方式不太好，可维护性太差劲
            const lineRect = group.getChildren()[3];
            lineRect?.attr('opacity', value ? 1 : 0);
        }
    }
});

export default {
    /**
     * 在G6中注册节点类型
     * @param param0
     */
    registerNode({ nodeType, iconText, type }) {
        // 节点半径
        const nodeCirceRadius = 22;
        // 节点的颜色设置
        // const colors = [
        //     {
        //         bgColor: '#CEEBFF',
        //         iconColor: '#3399FF'
        //     },
        //     {
        //         bgColor: '#FFEBEB',
        //         iconColor: '#FF3333'
        //     },
        //     {
        //         bgColor: '#E5F9F0',
        //         iconColor: '#00BB66'
        //     },
        //     {
        //         bgColor: '#E5F9F0',
        //         iconColor: '#00BB66'
        //     }
        // ];
        G6.registerNode(nodeType, {
            /**
             * 定制节点的内容
             * @param cfg 创建节点时候的对象
             * @param group g6的group
             */
            draw(cfg, group) {
                let keyShape = null;
                let content = cfg.label.replace(/[^\x00-\xff]/g, "$&\x01"); // 把所有中文字符分别转换为两个字符
                let timeVal = null; // 营销触点的节点，有发送/执行时间
                const timeHeight = Object(nodeTimeTitleSource).hasOwnProperty(cfg.type) ? 35 : 0;

                const rectHeight = (cfg.content || cfg.label) && cfg.type !== 'node-CROWD_DIG-2' ? (90 + (Math.ceil(content.length / 16) - 3) * 15 + timeHeight) : (70 + (cfg?.executionTime ? 25 : 0)); // 如果是复杂的展示节点，把节点既定的高设大一些。计算式的内容的含义是：16个字符折行，90px最多容纳3行，以此为基础多一行高度扩15px。这里现在只有人群节点特殊判断，因为人群节点是复杂节点里，唯一不用因为‘已设置’‘未设置’而拉高的；nodeTimeTitleSource是各个触达节点，这类节点需要展示发送时间，也需要加高。三目的false分支里，70 + xxx，是因为单次执行的任务，添加了时间设置功能，所以也要加高一点
                if (labelPositionFilter.indexOf(cfg.type) === -1) {
                    // 主要的shape 长方形图标的外扩
                    keyShape = group.addShape('rect', {
                        attrs: {
                            x: 0,
                            y: 0,
                            // r: nodeCirceRadius,
                            // fill: colors[type - 1].bgColor,
                            cursor: 'move',
                            stroke: '#B8BAC1',
                            fill: '#F6F6F6',
                            width: 170,
                            height: rectHeight,
                            radius: [5, 5],
                        },
                        name: CIRCLE_SHAPE_NAME,
                        draggable: true
                    });

                    //图标的icon 出现在圆形的中心位置
                    //测试小图标改成image是否缓解过多节点导致的卡顿
                    const icon = group.addShape('image', {
                        attrs: {
                            x: 10,
                            y: 10,
                            width: 40,
                            height: 40,
                            img: iconText,
                        },
                        name: CIRCLE_ICON_NAME,
                        draggable: true
                    });

                    // 节点的label
                    // let content = cfg.label.replace(/(.{9})/g, "$1\n")
                    content = content.replace(/.{16}\x01?/g, "$&\n").replace(/\x01/g, ""); // 说来话长，这个text不能折行，只能自己去手动替换成换行符，因为每行能容下16个字，那就隔16个添加一个换行符，然后再把 \x01 这个控制字符删掉
                    const label = group.addShape('text', {
                        attrs: {
                            text: !cfg.content && cfg.type === 'node-CROWD_DIG-2' ? nodeContentTitleSource[cfg.type] : content,
                            x: 55,
                            y: 10,
                            width: 95,
                            fontSize: 12,
                            textBaseline: 'top',
                            textAlign: 'left',
                            fill: '#333333',
                            cursor: 'move'
                        },
                        name: 'circle-label',
                        draggable: true
                    });

                    // 鱼和熊掌，想要定制dom节点，就没法用双击打开弹窗的click
                    // const label = group.addShape('dom', {
                    //     attrs: {
                    //       width: 95,
                    //       height: 60,
                    //       // DOM's html
                    //       html: `
                    //       <div style="word-break: 'break-word'">
                    //         <span style="margin:auto; padding:auto; color: #5B8FF9">${cfg.label}</span>
                    //       </div>
                    //         `,
                    //     },
                    //     // 在 G6 3.3 及之后的版本中，必须指定 name，可以是任意字符串，但需要在同一个自定义元素类型中保持唯一性
                    //     name: 'circle-label',
                    //     draggable: true,
                    // });

                    // 选中状态的外框
                    const focusRect = group?.addShape('rect', {
                        attrs: {
                            x: 0,
                            y: 0,
                            // r: 22,
                            width: 170,
                            height: rectHeight,
                            // stroke: 'rgb(255, 51, 51)',
                            stroke: '#3399ff',
                            opacity: 0,
                            // lineWidth: 2,
                            // shadowColor: 'rgb(255, 51, 51)',
                            // shadowBlur: 6
                            radius: [5, 5],
                            // zIndex: -999,
                            lineDash: [5,5,5]
                        },
                        name: FOCUS_MARK_NAME
                    });

                    // 根据需要已经不再根据节点类型对锚点做限制
                    // 如果是操作节点和任务节点，具有进入锚点
                    const leftAnchor = group!.addShape('image', {
                        attrs: {
                            x: -20,
                            y: rectHeight/2 - 10,
                            width: 18,
                            height: 18,
                            img: rightArrowIcon,
                            opacity: 0
                        },
                        name: LEFT_ANCHOR_NAME
                    });

                    // 如果是人群节点和操作出发，具有出发锚点
                    // if (type < 3) {}
                    const rightAnchor = group!.addShape('image', {
                        attrs: {
                            x: 170,
                            y: rectHeight/2 - 10,
                            width: 18,
                            height: 18,
                            img: rightArrowIcon,
                            opacity: 0
                        },
                        name: RIGHT_ANCHOR_NAME,
                        draggable: true
                    });

                    // 时间的次要信息
                    const time = group.addShape('text', {
                        attrs: {
                            text: cfg.time ? `执行时间：${cfg.time}` : '',
                            // width: 95,
                            // x: 55,
                            y: rectHeight + 10,
                            fontSize: 10,
                            textBaseline: 'top',
                            textAlign: 'left',
                            fill: '#333333',
                            cursor: 'move'
                        },
                        name: 'circle-time',
                        draggable: true
                    });

                    // 这两步是为了算出当前任务状态是预执行还是查看还是编辑
                    const result = window.location.href.split('/');
                    const ar = result[result.length-1] ? result[result.length-1] : result[result.length-2];

                    // 节点包含的部分数据
                    const count = group.addShape('text', {
                        attrs: {
                            text: cfg.count ? `${previewNodeLabel[cfg.type][ar]}：${cfg.count}` : '',
                            y: rectHeight + 25,
                            fontSize: 10,
                            textBaseline: 'top',
                            textAlign: 'left',
                            fill: '#ff3333',
                            cursor: 'move'
                        },
                        name: 'circle-count',
                        draggable: true
                    });

                    // 成功状态的标记
                    const successMarker = group?.addShape('image', {
                        attrs: {
                            x: 162,
                            y: -9,
                            width: 18,
                            height: 18,
                            img: checkSignIcon,
                            opacity: cfg.runState?.success ? 1 : 0
                        },
                        name: SUCCESS_MARK_NAME,
                        draggable: true
                    });

                    // 错误状态的标记
                    const errorMarker = group?.addShape('image', {
                        attrs: {
                            x: 162,
                            y: -9,
                            width: 18,
                            height: 18,
                            img: exclamatoryMarkIcon,
                            opacity: cfg.runState?.error ? 1 : 0
                        },
                        name: EORROR_MARKER_NAME,
                        draggable: true
                    });
                } else {
                    // 主要的shape 圆形图标的外扩
                    keyShape = group.addShape('circle', {
                        attrs: {
                            x: 0,
                            y: 20,
                            r: nodeCirceRadius,
                            // fill: colors[type - 1].bgColor,
                            cursor: 'move',
                        },
                        name: CIRCLE_SHAPE_NAME,
                        draggable: true,
                    });

                    //图标的icon 出现在圆形的中心位置
                    //测试小图标改成image是否缓解过多节点导致的卡顿
                    const icon = group.addShape('image', {
                        attrs: {
                            x: -20,
                            y: 0,
                            width: 40,
                            height: 40,
                            img: iconText,
                        },
                        name: CIRCLE_ICON_NAME,
                        draggable: true,
                    });

                    // 节点的label
                    const label = group.addShape('text', {
                        attrs: {
                            text: cfg.label,
                            y: 50,
                            fontSize: 12,
                            textBaseline: 'middle',
                            textAlign: 'center',
                            fill: '#333333',
                            cursor: 'move',
                        },
                        name: 'circle-label',
                        draggable: true,
                    });



                    // 时间的次要信息
                    const time = group.addShape('text', {
                        attrs: {
                            text: cfg.time ? `执行时间：${cfg.time}` : '',
                            // width: 95,
                            // x: 55,
                            y: rectHeight + 10,
                            fontSize: 10,
                            textBaseline: 'top',
                            textAlign: 'center',
                            fill: '#333333',
                            cursor: 'move'
                        },
                        name: 'circle-time',
                        draggable: true
                    });

                    // 这两步是为了算出当前任务状态是预执行还是查看还是编辑
                    const result = window.location.href.split('/');
                    const ar = result[result.length-1] ? result[result.length-1] : result[result.length-2];
                    // 节点包含的部分数据
                    const count = group.addShape('text', {
                        attrs: {
                            text: cfg.count ? ((noRunCrowdFilter.indexOf(cfg?.type) > -1) ? '' :`${ar === 'preview' ? '预估人群数' : '运行人群数'}：${cfg.count}`) : '',
                            y: rectHeight + 25,
                            fontSize: 10,
                            textBaseline: 'top',
                            textAlign: 'center',
                            fill: '#ff3333',
                            cursor: 'move'
                        },
                        name: 'circle-count',
                        draggable: true
                    });

                    // 根据需要已经不再根据节点类型对锚点做限制
                    // 如果是操作节点和任务节点，具有进入锚点
                    const leftAnchor = group!.addShape('image', {
                        attrs: {
                            x: -38,
                            y: 10,
                            width: 18,
                            height: 18,
                            img: rightArrowIcon,
                            opacity: 0,
                        },
                        name: LEFT_ANCHOR_NAME,
                    });

                    // 如果是人群节点和操作出发，具有出发锚点
                    // if (type < 3) {}
                    const rightAnchor = group!.addShape('image', {
                        attrs: {
                            x: 20,
                            y: 10,
                            width: 18,
                            height: 18,
                            img: rightArrowIcon,
                            opacity: 0,
                        },
                        name: RIGHT_ANCHOR_NAME,
                        draggable: true,
                    });

                    // 选中状态的外框
                    const focusRect = group?.addShape('circle', {
                        attrs: {
                            x: 0,
                            y: 20,
                            r: 20,
                            stroke: '#3399ff',
                            opacity: 0,
                            lineWidth: 2,
                            shadowColor: '#3399ff',
                            shadowBlur: 6,
                            lineDash: [5,5,5]
                        },
                        name: FOCUS_MARK_NAME,
                    })

                    // 成功状态的标记
                    const successMarker = group?.addShape('image', {
                        attrs: {
                            x: 16,
                            y: -16,
                            width: 18,
                            height: 18,
                            img: checkSignIcon,
                            opacity: cfg.runState?.success ? 1 : 0,
                        },
                        name: SUCCESS_MARK_NAME,
                        draggable: true,
                    });

                    // 错误状态的标记
                    const errorMarker = group?.addShape('image', {
                        attrs: {
                            x: 16,
                            y: -16,
                            width: 18,
                            height: 18,
                            img: exclamatoryMarkIcon,
                            opacity: cfg.runState?.error ? 1 : 0,
                        },
                        name: EORROR_MARKER_NAME,
                        draggable: true,
                    });
                }

                // 复杂类型，展示配置项是否已设置
                if (["node-MARKETING_SMS-2", "node-MARKETING_RICH_SMS-2", "node-MARKETING_RICH_TEXT_SMS-2", "node-MARKETING_MSG_BOX-2", "node-MARKETING_COUPON-2", "node-MARKETING_PACKAGE_ANALYSIS-2", "node-MARKETING_DONGDONG-2"].indexOf(cfg.type) > -1) {
                    const richContent = group.addShape('text', {
                        attrs: {
                            text: `${nodeContentTitleSource[cfg.type]}` + `${!cfg.content ? '未设置' : '已设置'}`,
                            x: 55,
                            y: rectHeight - 10,
                            fontSize: 10,
                            textBaseline: 'bottom',
                            textAlign: 'left',
                            fill: '#333333',
                            cursor: 'move',
                        },
                        name: 'circle-label',
                        draggable: true,
                    });
                }
                // 营销触点类节点的发送时间
                if (Object(nodeTimeTitleSource).hasOwnProperty(cfg.type)) {
                    // 依旧是把换行符拼进去
                    const timeVal = JSON.stringify(cfg.executionTime)?.replace(/.{21}\x01?/g, "$&\n")?.replace(/\x01/g, "");
                    const richTime = group.addShape('text', {
                        attrs: {
                            text: `${nodeTimeTitleSource[cfg.type]}` + `${cfg.executionTime === 0 ? '立即执行' : !cfg.executionTime ? '未设置' : `\n${timeVal}`}`,
                            x: 55,
                            y: rectHeight - 25,
                            fontSize: 10,
                            textBaseline: 'bottom',
                            textAlign: 'left',
                            fill: '#333333',
                            cursor: 'move',
                        },
                        name: 'circle-label',
                        draggable: true,
                    });
                }
                // 抽取排除节点展示目标人群
                if (targetCrowdFilter.indexOf(cfg.type) > -1) {
                    if(cfg.type === 'node-CROWD_DIFFERENCE-2' && cfg.differenceType === 2) {
                        return;
                    }
                    const targetCrowd = group.addShape('text', {
                        attrs: {
                            text: '目标人群：' + `${!cfg.targetCrowd.length ? '未设置' : cfg.targetCrowd}`,
                            y: 70,
                            fontSize: 12,
                            textBaseline: 'bottom',
                            textAlign: 'center',
                            fill: '#333333',
                            cursor: 'move',
                        },
                        name: 'circle-label',
                        draggable: true,
                    });
                }

                return keyShape;
            },
            // 节点在不同状态下的显示
            // TODO: 正常应该使用官方提供的stateStyles来解决这个问题但是官网的api不好用。。。
            setState(name, value, item) {
                const group = item!.getContainer();
                // 鼠标移动到节点上显示节点的出发锚点
                if (name === 'hover') {
                    // 人群选择节点鼠标悬浮的时候，要判断该节点是否已选人群，如果未选，则不显示拖拽的 → 箭头
                    if (
                        item?._cfg.currentShape === 'node-CROWD_DIG-2' &&
                        !item._cfg.model.fillComplete
                    ) {
                        group
                            .find(c => c.get('name') === RIGHT_ANCHOR_NAME)
                            .attr('opacity', 0);
                        group
                            .find(c => c.get('name') === RIGHT_ANCHOR_NAME)
                            .attr('width', 0); //18
                        group
                            .find(c => c.get('name') === RIGHT_ANCHOR_NAME)
                            .attr('x', 0); //26
                        group
                            .find(c => c.get('name') === RIGHT_ANCHOR_NAME)
                            .attr('y', 0); //9
                    } else {
                        const leftAnchor = group.find(
                            c => c.get('name') === LEFT_ANCHOR_NAME
                        );
                        leftAnchor.attr('opacity', 0);
                        if (noPostNodeFilter.indexOf(item._cfg.model.type) === -1) {
                            const rightAnchor = group.find(
                                c => c.get('name') === RIGHT_ANCHOR_NAME
                            );
                            rightAnchor.attr('opacity', value ? 1 : 0);
                        }
                    }
                }

                // 有元素处于拖拽连线中时，显示进入锚点
                if (name === TO_LINK) {
                    // console.log(group.find(c => c.get('name') === LEFT_ANCHOR_NAME),'有进入锚点的');

                    const leftAnchor = group.find(
                        c => c.get('name') === LEFT_ANCHOR_NAME
                    );
                    leftAnchor.attr('opacity', value ? 1 : 0);
                }

                // 有元素处于拖拽连线中时，显示进入锚点
                if (name === TO_NOT_LINK) {
                    const mainCircle = group.find(
                        c => c.get('name') === CIRCLE_SHAPE_NAME
                    );
                    const mainIcon = group.find(
                        c => c.get('name') === CIRCLE_ICON_NAME
                    );
                    mainCircle.attr('opacity', value ? 0.5 : 1);
                    mainIcon.attr('opacity', value ? 0.2 : 1);
                }

                // 元素选中状态的处理
                if (name === 'focus') {
                    const focusRect = group.find(
                        c => c.get('name') === FOCUS_MARK_NAME
                    );
                    focusRect.attr('opacity', value ? 1 : 0);
                }

                // 元素错误状态的处理
                if (name === 'error') {
                    const errorMarker = group.find(
                        c => c.get('name') === EORROR_MARKER_NAME
                    );
                    errorMarker.attr('opacity', value ? 1 : 0);
                }

                // 元素成功状态的处理
                if (name === 'success') {
                    const successMarker = group.find(
                        c => c.get('name') === SUCCESS_MARK_NAME
                    );
                    successMarker.attr('opacity', value ? 1 : 0);
                }
            }
        });
    },
    create(elm, width, height, pageType) {
        // 画布的物理像素大小
        const canvasPxSize = {
            width, // 画布的宽度
            height // 画布的高度
        };

        let canvasType = pageType;

        const modes = {
            default: [
                {
                    type: 'drag-node', // 节点可以拖拽
                    shouldBegin(e) {
                        // 如果是从锚点出发则不移动节点而是，拉线
                        return e.shape.cfg.name !== RIGHT_ANCHOR_NAME;
                    }
                },
                'click-select', // 元素可以点选
                {
                    type: 'brush-select', // 元素可以框选
                    trigger: 'drag'
                },
                {
                    type: 'scroll-canvas', // 整个画布可以滚动
                    direction: 'y',
                },
                'drag-combo',
                'collapse-expand-combo'
            ],
            chooseMode: [
                {
                    type: 'drag-node', // 节点可以拖拽
                    shouldBegin(e) {
                        // 如果是从锚点出发则不移动节点而是，拉线
                        return e.shape.cfg.name !== RIGHT_ANCHOR_NAME;
                    }
                },
                'click-select', // 元素可以点选
                'zoom-canvas', // 整个画布可以缩放
                'drag-canvas', // 整个画布可以拖拽
                'drag-combo',
                'collapse-expand-combo'
            ],
            // dragMode: [
            //     {
            //         type: 'drag-node', // 节点可以拖拽
            //         shouldBegin(e) {
            //             // 如果是从锚点出发则不移动节点而是，拉线
            //             return e.shape.cfg.name !== RIGHT_ANCHOR_NAME;
            //         }
            //     },
            //     'click-select', // 元素可以点选
            //     'drag-canvas', // 整个画布可以拖拽
            //     'drag-combo',
            //     'collapse-expand-combo'
            // ],
        };
        if (canvasType === 'editor') {
            modes.default.push({
                type: 'create-edge', // 可以连接节点
                trigger: 'drag', // 使用拖拽连接节点
                shouldBegin(e) {
                    // 从允许的锚点出发才可以拉线
                    return e.shape.cfg.name === RIGHT_ANCHOR_NAME;
                },
                shouldEnd(e) {
                    // 筛选连线结束节点
                    return e.item.hasState(TO_LINK);
                    // return e.shape.cfg.name === LEFT_ANCHOR_NAME;
                }
            });
        }
        // 创建画布
        const graph = new G6.Graph({
            container: elm, // 挂载的dom节点
            ...canvasPxSize,
            renderer: 'canvas', // 使用canvas绘制
            enabledStack: true, // 激活undo redo
            plugins: [
                // 缩略图插件
                new G6.Minimap({
                    size: [200, 140],
                    className: 'minimap'
                }),
                // tooltip插件
                new G6.Tooltip({
                    offsetX: -350,
                    offsetY: -100,
                    getContent(e) {
                        // 获取错误信息
                        return e.item._cfg.model.runState?.errorMessage || '';
                    },
                    shouldBegin(e) {
                        // 有错误节点的错误标记处显示错误信息
                        return (
                            e.target.cfg.name === 'error_marker' &&
                            e.item._cfg.model.runState?.error
                        );
                    },
                    // 只在节点上生效
                    itemTypes: ['node'],
                    // fixToNode: [0, 0],
                }),
                // 人群选择节点，未选人群时，隐藏右侧箭头，加tooltip弹窗
                new G6.Tooltip({
                    offsetX: -350,
                    offsetY: -100,
                    getContent(e) {
                        return '选择人群包后才可以连接其他节点';
                    },
                    shouldBegin(e) {
                        // 人群选择节点 && 未选人群
                        return (e.item._cfg.currentShape === 'node-CROWD_DIG-2' &&
                        !e.item._cfg.model.fillComplete);
                    },
                    // 只在节点上生效
                    itemTypes: ['node'],
                    // fixToNode: [0, 0.5],
                })
            ],
            modes,
            nodeStateStyles: {
                // 鼠标 hover 上节点，即 hover 状态为 true 时的样式
                hover: {
                    fill: 'lightsteelblue'
                },
                // 鼠标点击节点，即 click 状态为 true 时的样式
                click: {
                    stroke: '#000',
                    lineWidth: 3
                }
            },
            // 默认的节点设置
            defaultNode: {
                // 通用的锚点设置
                anchorPoints: [
                    [0, 0.5],
                    [1, 0.5]
                ]
            },
            // 默认的边设置
            defaultEdge: {
                type: 'lz-edge', // 自定义的边线
                style: {
                    stroke: '#657180', // 线色
                    lineWidth: 1, // 线宽
                    cursor: 'pointer',
                    sourceAnchor: 1,
                    // // 该边连入 source 点的第 1 个 anchorPoint，
                    targetAnchor: 0,
                    endArrow: true // 尾端箭头
                }
            },
            fitView: true,
            maxZoom: 2
        });

        graph.on('wheelzoom', (e) => {
            e.stopPropagation();
            // 这里的 className 根据实际情况而定，默认是 g6-component-tooltip
            const tooltips = Array.from(document.getElementsByClassName('g6-component-tooltip'));
            tooltips.forEach((tooltip) => {
              if (tooltip && tooltip.style) {
                tooltip.style.transform = `scale(${graph.getZoom()})`;
              }
            });
        });

        const zoom = time => {
            const factor = 0.5;
            const zoom =
                time > 0
                    ? graph.getZoom() * (1 + time * factor)
                    : graph.getZoom() / (1 - time * factor);
            graph.zoomTo(zoom);
        };

        /**
         * 按住ctrl多选节点和边，给节点和边添加选中样式，设置节点和边选中状态(框选和点击节点才触发)
         */
        graph.on('nodeselectchange', e => {
            if (e.selectedItems) {
                const focusNodeIds = []; //此次点击的节点
                const focusEdgeIds = []; //此次点击的线
                e.selectedItems?.nodes.forEach(item => {
                    focusNodeIds.push(item._cfg.id);
                });
                e.selectedItems?.edges?.forEach(item => {
                    focusEdgeIds.push(item._cfg.id);
                });
                if (graph.getCurrentMode() === 'default') {
                    //普通模式下，选中某个点，将所有线置为非选中状态
                    graph
                        .getNodes()
                        .forEach(node =>
                            graph.setItemState(
                                node,
                                'focus',
                                focusNodeIds.indexOf(node._cfg!.id) == -1
                                    ? false
                                    : true
                            )
                        );
                    graph
                        .getEdges()
                        .forEach(edge =>
                            graph.setItemState(edge, 'selected', false)
                        );
                } else if (graph.getCurrentMode() === 'chooseMode') {
                    //选择模式下
                    const focusedNodeIds = []; //之前已经选中的节点id
                    graph.getNodes().forEach(node => {
                        if (node._cfg?.states?.includes('focus')) {
                            focusedNodeIds.push(node._cfg.id);
                        }
                    });
                    if (focusNodeIds.length === 1) {
                        // 判断之前已经选中的节点是否包含此次点击的节点
                        const hasFlag = !focusedNodeIds.includes(
                            focusNodeIds.toString()
                        );
                        graph.setItemState(
                            e.selectedItems.nodes[0],
                            'focus',
                            hasFlag
                        );
                    } else {
                        graph.getNodes().forEach(node => {
                            graph.setItemState(
                                node,
                                'focus',
                                focusNodeIds.indexOf(node._cfg!.id) == -1
                                    ? false
                                    : true
                            );
                        });
                    }
                }
            }
        });

        // 收起鼠标右键出现的操作菜单
        const packUpContextMenu = () => {
            var menu1 = document.getElementById('contextMenuNode');
            var menu2 = document.getElementById('contextMenuCanvas');
            menu1.style.display = 'none';
            menu2.style.display = 'none';
            // sessionStorage.setItem('lz-cjyx-canvas-contextmenu-node', '');
        };

        /**
         * 点击画布
         */
        graph.on('canvas:click', evt => {
            packUpContextMenu();

            // console.log(graph.getCombos().length);
            if (graph.getCombos().length > 0) {
                graph.uncombo('combo');
            }
            graph
                .getEdges()
                .forEach(edge => graph.setItemState(edge, 'selected', false));
        });

        // 组合节点hover事件
        graph.on('node:mouseenter', e => {
            const nodeItem = e.item; // 获取被点击的节点元素对象
            if (canvasType === 'editor') {
                graph.setItemState(nodeItem, 'hover', true);
            }
        });
        graph.on('node:mouseleave', e => {
            const nodeItem = e.item; // 获取被点击的节点元素对象
            graph.setItemState(nodeItem, 'hover', false);
        });

        /**
         * 连接校验函数，这个函数在使用setLinkValidator之后会被覆盖，
         * @param sourceId 出发节点id
         * @param targetId 进入节点id
         */
        let linkValidator = (sourceId, targetId) => {
            return sourceId !== targetId;
        };
        // 拖拽连线的过程中的设置可连接的节点
        graph.on('node:dragstart', e => {
            if (e.shape.cfg.name === RIGHT_ANCHOR_NAME) {
                const nodeItem = e.item; // 获取被点击的节点元素对象
                const sourceId = e.item._cfg.id;
                // 建立黑名单
                const blackList = [sourceId];
                // 将已经与出发节点连接的元素的id加入黑名单
                graph.getEdges().filter(
                    edge =>
                        edge._cfg.model.source === sourceId ||
                        edge._cfg.model.target === sourceId
                ).forEach(edge => {
                    blackList.push(edge._cfg.model.source);
                    blackList.push(edge._cfg.model.target);
                });
                // 将黑名单以外的节点设置为可进入的目标节点，在节点的状态上写入toLink状态
                graph.getNodes().forEach(node => {
                    if (
                        blackList.indexOf(node._cfg?.id) === -1 &&
                        linkValidator(sourceId, node._cfg?.id)
                    ) {
                        graph.setItemState(node, TO_LINK, true);
                    } else {
                        graph.setItemState(node, TO_NOT_LINK, true);
                    }
                });
            }
        });
        graph.on('dragend', e => {
            // 拖拽结束清除所有节点的toLink状态
            graph.getNodes().forEach(node => {
                graph.setItemState(node, TO_LINK, false);
                graph.setItemState(node, TO_NOT_LINK, false);
            });
        });

        // 节点单击鼠标右键展示操作项
        graph.on('node:contextmenu', function (evt) {
            if (canvasType === 'editor') {
                evt.preventDefault(); // 去除默认
                evt.stopPropagation(); // 去除冒泡
                let menu = document.getElementById('contextMenuNode');
                menu.style.display = 'block';
                menu.style.left = evt.canvasX + 30 + 'px';
                menu.style.top = evt.canvasY + 30 + 'px';

                // 为后续可以计算能够连接什么节点，所以此处清除对于除此节点以为的其他选中状态，将当前节点选中
                // graph.getNodes().forEach(node => {
                //     if (evt.item._cfg.id !== node._cfg.id) {
                //         graph.clearItemStates(node);
                //     } else {
                const currertClickNode = graph.findById(evt.item._cfg.model.id);
                graph.setItemState(currertClickNode, 'focus', true);
                sessionStorage.setItem('lz-cjyx-canvas-contextmenu-node', evt.item._cfg.model.id);
                //     }
                // })
            }
        });
        // 画布范围单击鼠标右键展示操作项
        graph.on('canvas:contextmenu', function (evt) {
            if (canvasType === 'editor') {
                evt.preventDefault(); // 去除默认
                evt.stopPropagation(); // 去除冒泡
                let menu = document.getElementById('contextMenuCanvas');
                menu.style.display = 'block';
                menu.style.left = evt.canvasX + 30 + 'px';
                menu.style.top = evt.canvasY + 30 + 'px';
            }
        });
        // graph.on('node:mouseleave', function(evt) {
        //     var menu1 = document.getElementById('contextMenuNode');
        //     var menu2 = document.getElementById('contextMenuCanvas');
        //     menu1.style.left = '-100px';
        //     menu2.style.left = '-100px';
        // });

        graph.on('combo:dragend', e => {
            graph.expandCombo('combo');
        });

        /**
         * 画布被点击统一处理被点击的元素添加selected的状态，未被选中的元素清除selected的状态
         */
        graph.on('edge:click', e => {
            if (canvasType === 'editor') {
                // 只在编辑页面生效
                packUpContextMenu(); // 清除鼠标右键展示的菜单
                const item = e.item; // 获取被点击的边对象
                if (graph.getCurrentMode() === 'default') {
                    // 默认模式，线只可以单选，点击线的时候，节点全部置为未选中
                    graph
                        .getNodes()
                        .forEach(node =>
                            graph.setItemState(node, 'focus', false)
                        );
                    if (item && item._cfg && item._cfg.id) {
                        graph.getEdges().forEach(edge => {
                            if (item._cfg.id === edge._cfg.id) {
                                graph.setItemState(
                                    edge,
                                    'selected',
                                    edge._cfg.states.length === 0 ? true : false
                                );
                            } else {
                                graph.setItemState(edge, 'selected', false);
                            }
                        });
                    }
                } else if (graph.getCurrentMode() === 'chooseMode') {
                    // 多选模式，线按住ctrl时，可多选
                    if (item && item._cfg && item._cfg.id) {
                        graph.getEdges().forEach(edge => {
                            if (item._cfg.id === edge._cfg.id) {
                                graph.setItemState(
                                    edge,
                                    'selected',
                                    edge._cfg.states.length === 0 ? true : false
                                );
                            }
                        });
                    }
                }
            }
        });

        /**
         * 画布被点击统一处理被点击的元素添加focus的状态，未被选中的元素清除focus的状态
         */
        graph.on('dblclick', e => {
            packUpContextMenu(); // 清除鼠标右键展示的菜单
            graph
                .getEdges()
                .forEach(edge => graph.setItemState(edge, 'focus', false));
            graph
                .getNodes()
                .forEach(node => graph.setItemState(node, 'focus', false));
        });

        /**
         * 点击节点
         */
        graph.on('node:click', e => {
            packUpContextMenu(); // 清除鼠标右键展示的菜单
        });

        /**
         * 添加边
         * @param id
         * @param source 出发节点
         * @param target 进入节点
         */
        const addEdge = (id, source, target, label = '') => {
            graph.add(
                'edge',
                {
                    id,
                    source,
                    target,
                    label,
                },
                false
            );
        };

        /**
         * 获取选中的节点的id列表
         */
        const getFocusItems = () => {
            return graph
                .getNodes()
                .filter(node => node.hasState('focus'))
                .map(node => node._cfg.id);
        };
        /**
         * 获取选中的节点列表
         */
        const getFocusNodes = () => {
            return graph.getNodes().filter(node => node.hasState('focus'));
        };
        /**
         * 获取选中的线的元素列表
         */
        const getFocusEdges = () => {
            return graph.getEdges().filter(edge => edge.hasState('selected'));
        };
        /**
         * 获取所有节点的节点id列表
         */
        const getAllNodeIds = () => {
            return graph.getNodes().map(n => n._cfg.id);
        };
        /**
         * 获取所有节点
         */
        const getAllNodes = () => {
            return graph.getNodes();
        };
        //测试
        const changeGraphSize = (changedWidth, changedHeight) => {
            graph.changeSize(changedWidth, changedHeight);
        };
        /**
         * 获取被选中的节点个数
         */
        const getFocusNode = () => {
            return (
                graph.getNodes().filter(node => node.hasState('focus')).length +
                graph.getEdges().filter(edge => edge.hasState('selected'))
                    .length
            );
        };

        /**
         * 根据Id获取节点
         */
        const getNodeById = id => {
            return graph.findById(id);
        };

        /**
         * 根据Id删除节点
         */
        const deleteNodeById = id => {
            graph.remove(graph.findById(id), true);
        };

        /**
         * 删除当前处于focus状态的元素，这个方法注意，如果不是在index.tsx里调用的，一定要传参，本文件里调用传inner
         * OuterTrigger 证明是index.tsx里触发的，这样不用event.emit了，因为tsx里自己删除nodeData数据了
         */
        const deleteFocusItem = (type = 'OuterTrigger') => {
            // 删除状态中含有focus的node
            graph
                .getNodes()
                .filter(node => node.hasState('focus'))
                .forEach(node => {
                    if (type !== 'OuterTrigger') {
                        event.emit('delete-canvas-node', node)
                    }
                    graph.remove(node, true);
                });
            // 删除状态中含有focus的edge
            graph
                .getEdges()
                .filter(edge => edge.hasState('selected'))
                .forEach(edge => {
                    graph.remove(edge, false);
                });
        };

        /**
         * 复制节点
         * @param oldNodeId 要被复制的节点的id
         * @param newNodeId 新生成的节点的id
         * @param coordinate 当前画布上已保存过的节点坐标
         * @param type 标识当前这个是什么节点
         */
        const copyNode = (oldNodeId, newNodeId, cfg, coordinate, type = '') => {
            const oldNode = graph.findById(oldNodeId); //要被复制的旧节点
            let newNodeX = oldNode._cfg.model.x + 100; //要生成的新节点x坐标
            let findNode = {}; //查找要生成新节点右侧100像素处是否有节点
            let oldNodeX = []; //与要被复制的旧节点y坐标相同的所有节点的x坐标集合
            if (coordinate?.nodes?.length > 0) {
                //现在画布上已经有节点
                findNode = coordinate.nodes.find(node => {
                    //要生成新节点右侧100像素处是否有节点
                    return newNodeX === node.x + 100;
                });
            }
            if (findNode && Object.keys(findNode).length > 0) {
                //有
                coordinate?.nodes.forEach(node => {
                    if (node.y === findNode.y) {
                        oldNodeX.push(node.x);
                    }
                });
            }
            const copyNodeIds = []; //已复制的节点id数组，用来判断当前要被复制的节点之后的x+100像素位置是否有节点，如果有，则x取复制节点当中最大的x+100，避免节点重叠
            graph
                .getStackData()
                .undoStack.filter(
                    node => node.action == 'add' || node.action == 'update'
                )
                .forEach(node => {
                    node.data.after?.nodes?.forEach(node => {
                        oldNodeX.push(node.x);
                    });
                });
            if (oldNodeX.indexOf(oldNode._cfg.model.x + 100) > -1) {
                //当前要被复制节点右侧100像素处有节点
                newNodeX = Math.max(...oldNodeX) + 100; //找到最大的x，将新节点放在最大x的右侧100像素处
            }
            graph.add(
                'node',
                {
                    ...oldNode._cfg.model,
                    id: newNodeId,
                    ...cfg,
                    x: newNodeX,
                    comboId: 'combo'
                },
                true
            );
            const copyNodes = [];
            copyNodes.push(newNodeId);
            // 复制富信节点，才需要重新更新节点状态
            if(type === 'MARKETING_RICH_TEXT_SMS') {
                graph.updateItem(newNodeId, {
                    content: false,
                })
            }
        };

        /**
         * 多选选框
         */
        const createComboForCopy = (ids) => {
            if (graph.getCombos().length > 0) {
                graph.uncombo('combo');
            }
            graph.createCombo(
                {
                    id: 'combo',
                    type: 'circle',
                    labelCfg: {
                        position: 'top',
                        refY: -50,
                        style: {
                            fontSize: 16
                        }
                    },
                    label:
                        '拖动到想要放置的位置' +
                        '\n' +
                        '在区域外单击取消选中',
                    style: {
                        // fill: '#666',
                    }
                },
                ids
            );
        };

        /**
         * 清除所有节点和线的状态
         */
        const clearAllStates = () => {
            graph.getNodes().forEach(node => graph.clearItemStates(node));
            graph.getEdges().forEach(edge => graph.clearItemStates(edge));
        };

        /**
         * 全选页面所有节点及边
         */
        const selectAll = () => {
            packUpContextMenu(); // 清除鼠标右键节点事件
            graph
                .getEdges()
                .forEach(edge => graph.setItemState(edge, 'focus', true));
            graph
                .getNodes()
                .forEach(node => graph.setItemState(node, 'focus', true));
        }

        /**
         * 键盘按键弹起事件处理函数
         * @param event 键盘事件event
         */
        const keyUpListener = event => {
            switch (event.code) {
                case 'Backspace': // keyCode: 8
                    // 后退按钮
                    // 在编辑页面删除页面选中元素
                    if (canvasType === 'editor') {
                        deleteFocusItem('inner');
                    }
                    break;
                case 'Escape': // keyCode: 27
                    // esc
                    break;
                case 'Enter': // keyCode: 13
                    // 回车
                    break;
                case 'Delete': // keyCode: 46
                    // delete按钮
                    // 在编辑页面删除页面选中元素
                    if (canvasType === 'editor') {
                        deleteFocusItem('inner');
                    }
                    break;
                case 'KeyY': // keyCode: 89
                    // Y键，恢复上一步
                    if (canvasType === 'editor' && event.ctrlKey) {
                        redo();
                    }
                    break;
                case 'KeyZ': // keyCode: 90
                    // Z键，撤销上一步
                    if (canvasType === 'editor' && event.ctrlKey) {
                        undo();
                    }
                    break;
                case 'KeyA':
                    // A键，全选节点及线
                    if (canvasType === 'editor' && event.ctrlKey) {
                        selectAll();
                    }
                    break;

                // case 'KeyC':
                //     // C键，复制
                //     if (canvasType === 'editor' && event.ctrlKey) {
                //         iceEvent.emit('copySelectItems', true)
                //     }
                //     break;
                // case 'KeyV':
                //     // V键，粘贴
                //     if (canvasType === 'editor' && event.ctrlKey) {
                //         iceEvent.emit('pasteItems', true)
                //     }
                //     break;
                case 'ControlLeft':
                    if (canvasType === 'editor') {
                        graph.setMode('default');
                    }
                    break;
                // case 'Space':
                //     if (canvasType === 'editor') {
                //         graph.setMode('default');
                //     }
                //     break;
            }
        };

        const keyDownListener = event => {
            switch (event.code) {
                // case 'Space':
                //     if (canvasType === 'editor') {
                //         console.log('尽力阿里');
                //         graph.setMode('dragMode');
                //     }
                //     break;
                case 'ControlLeft':
                    if (canvasType === 'editor') {
                        graph.setMode('chooseMode');
                    }
                    break;
            }
        };
        // /**
        //  * 按键事件监听(释放键盘键触发该事件)
        //  */
        // graph.on('keyup', keyUpListener);

        // /**
        //  * 按键事件监听(按下键盘键触发该事件)
        //  */
        // graph.on('keydown', keyDownListener);

        graph.on('canvas:mouseenter',()=>{
            /**
             * 按键事件监听(释放键盘键触发该事件)
             */
            graph.on('keyup', keyUpListener);

            /**
             * 按键事件监听(按下键盘键触发该事件)
             */
            graph.on('keydown', keyDownListener);
        })

        graph.on('canvas:mouseleave',()=>{
            /**
             * 按键事件监听(释放键盘键触发该事件)
             */
            graph.off('keyup', keyUpListener);

            /**
             * 按键事件监听(按下键盘键触发该事件)
             */
            graph.off('keydown', keyDownListener);
        })

        /**
         * 设置画布模式
         */
        const setMode = (type) => {
            graph.setMode(type)
        }

        /**
         * 撤销操作
         */
        const undo = () => {
            packUpContextMenu(); // 清除鼠标右键节点事件
            // 从undo栈中获取最后一次的操作记录
            const stackItem = graph.getUndoStack().pop();
            // 如果栈中有记录
            if (stackItem) {
                // 根据栈中的操作类型进行不同的数据还原
                switch (stackItem.action) {
                    case 'add':
                        // 最后一次的操作是添加元素
                        // 遍历添加的节点删除对应的节点
                        stackItem.data.after.nodes?.forEach((node, index) => {
                            // 查找操作的节点
                            const item = graph.findById(node.id);
                            stackItem.data.after.nodes[index] = JSON.parse(JSON.stringify(item._cfg?.model)); // 由于v3.0涉及到人群选择、短信、富信等类型的节点内容是否已选择已设置，这里就把真实数据赋值到stack的数据上去
                            // 移除节点 注意次操作不能压栈
                            graph.remove(item, false);
                            event.emit('delete-canvas-node', item);
                        });
                        // // 遍历边，删除对应的item
                        stackItem.data.after.edges?.forEach(edge => {
                          // 查找操作的边
                          const item = graph.findById(edge.id)
                          // 移除边 注意次操作不能压栈
                          graph.remove(item, false);
                        })
                        break;
                    case 'update':
                        // 最后一次操作是更新
                        stackItem.data.before.nodes?.forEach(node => {
                            // 查找操作的节点
                            const item = graph.findById(node.id);
                            // 把操作前节点的状态更新到节点中，此处操作不压栈
                            graph.update(item, node, false);
                        });
                        // 遍历边
                        stackItem.data.before.edges?.forEach(edge => {
                          // 查找操作的边
                            const item = graph.findById(edge.id);
                            // 如果item能得到，证明上次是连了一条线，如果没找到，证明是删除了某条线
                            if (item) {
                                graph.remove(item, false);
                            } else {
                                addEdge(
                                    UUID.getUUID32(),
                                    edge.source,
                                    stackItem.data.after?.edges[0].target,
                                )
                            }
                        })
                        break;
                    case 'delete':
                        // 最后一次的操作是删除
                        // 遍历被删除的节点添加回去
                        stackItem.data.before.nodes?.forEach(node => {
                            console.log('node', node)
                            // 移除节点 注意此操作不需要压栈 "node-CROWD_DIG-2"
                            if (node.type !== 'node-CROWD_DIG_BATCH-2' && node.type !== 'node-CROWD_SPLIT_2-2') {
                                // 人群批量选择不能作为一个节点生成在canvas里，这里不add它
                                graph.add('node', node, false);
                                if(node.type === 'node-MARKETING_DONGDONG-2') {
                                    graph.updateItem(node.id, {
                                        content: false,
                                        executionTime: false
                                    })
                                }
                                event.emit('add-canvas-node', node)
                            }
                        });
                        // 遍历被删除的边添加回去
                        stackItem.data.before.edges?.forEach(edge => {
                            // 移除边 注意此操作需要压栈
                            graph.add('edge', edge, false);
                        });
                        break;
                }
                // 将对应的记录押入redo栈中
                graph.pushStack(stackItem.action, stackItem.data, 'redo');
            }
        };

        /**
         * 恢复操作
         */
        const redo = () => {
            packUpContextMenu(); // 清除鼠标右键节点事件
            const stackItem = graph.getRedoStack().pop();
            // 如果存在这条操作记录
            if (stackItem) {
                // 将对应的记录押入undo栈中
                // 根据栈中的操作类型进行不同的数据还原
                switch (stackItem.action) {
                    case 'add':
                        // 添加元素
                        // 遍历添加的节点删除对应的节点
                        stackItem.data.after.nodes?.forEach(node => {
                            // 移除节点 注意此操作需要压栈
                            if (node.type !== 'node-CROWD_DIG_BATCH-2' && node.type !== 'node-CROWD_SPLIT_2-2') {
                                // 人群批量选择不能作为一个节点生成在canvas里，这里不add它
                                graph.add('node', node, true);
                                event.emit('add-canvas-node', node);
                            }
                        });
                        // 遍历添加的边删除对应的边
                        stackItem.data.after.edges?.forEach(edge => {
                            // 移除边 注意此操作需要压栈
                            graph.add('edge', edge, true);
                        });
                        break;
                    case 'update':
                        // 最后一次操作是更新
                        stackItem.data.before.nodes?.forEach(node => {
                            // 查找操作的节点
                            const item = graph.findById(node.id);
                            // 把操作前节点的状态更新到节点中，此处操作压栈
                            graph.update(item, node, true);
                        });
                        // 遍历边
                        // stackItem.data.before.edges?.forEach(edge => {
                        //   // 查找操作的边
                        //   const item = graph.findById(edge.id)
                        //   // 移除边 压栈
                        // //   graph.update(item, edge, true)
                        //     graph.add('edge', edge, true);
                        // })

                        // 遍历边
                        stackItem.data.before.edges?.forEach(edge => {
                            // 查找操作的边
                              const item = graph.findById(edge.id);
                              // 如果item能得到，证明上次是连了一条线，如果没找到，证明是删除了某条线
                              if (item) {
                                graph.remove(item, false);
                              } else {
                                addEdge(
                                    UUID.getUUID32(),
                                    edge.source,
                                    stackItem.data.after?.edges[0].target,
                                )
                                //   graph.remove(item, false);
                              }
                          })
                        break;
                    case 'delete':
                        // 最后一次的操作是删除
                        stackItem.data.before.nodes?.forEach(node => {
                            // 查找操作的节点
                            const item = graph.findById(node.id);
                            // 移除节点 压栈
                            graph.remove(item, false);
                            event.emit('delete-canvas-node', item)
                        });
                        stackItem.data.before.edges?.forEach(edge => {
                            // 查找操作的边
                            const item = graph.findById(edge.id);
                            // 移除边 压栈
                            graph.remove(item, true);
                        });
                        break;
                }
            }
            // 将对应的记录押入undo栈中
            graph.pushStack(stackItem.action, stackItem.data);
        };

        /**
         * 查询前置节点的id列表（可能有多个前置节点）
         * @param id 要查询的节点的节点id
         */
        const getPrevNodeIds = id => {
            return (
                graph
                    .findById(id)
                    ?._cfg.edges?.filter(edge => edge._cfg.model.target === id)
                    .map(edge => edge._cfg.model.source) || []
            );
        };
        /**
         * 查询后置节点的id列表（可能有多个后置节点）
         * @param id 要查询的节点的节点id
         */
        const getNextNodeIds = id => {
            return (
                graph
                    .findById(id)
                    ?._cfg.edges?.filter(edge => edge._cfg.model.source === id)
                    .map(edge => edge._cfg.model.target) || []
            );
        };

        // 画图位置和zoom重置
        const resetPos = () => {
            graph.zoomTo(1);
            graph.moveTo(0, 0);
        };

        return {
            /**
             * 获取graph实例
             */
            getInstance() {
                return graph;
            },

            /**
             * 节点上绑定双击的事件处理函数
             * @param handler 双击节点的事件处理函数
             */
            onNodeDblClick(handler) {
                graph.on('node:dblclick', e => {
                    const nodeItem = e.item; // 获取被点击的节点元素对象
                    handler(nodeItem._cfg.id);
                });
            },

            /**
             * 节点上绑定单击的事件处理函数
             * @param handler 单击节点的事件处理函数
             */
            //  onNodeClick (handler) {
            //    // 绑定节点点击事件
            //    graph.on('node:click', e => {
            //      const nodeItem = e.item;  // 获取被点击的节点元素对象
            //      handler(nodeItem._cfg.id);
            //    });
            //  },

            /**
             * 添加节点
             * @param nodeId 节点的ID
             * @param node 节点的相关信息
             * @param x 节点要添加的位置相对于画布左上角的像素大小
             * @param y 节点要添加的位置相对于画布左上角的像素大小
             */
            addNode(nodeId, node, x, y) {
                // const z = graph.getZoom();
                const pos = graph.getPointByClient(x, y);
                graph.add(
                    'node',
                    {
                        id: nodeId,
                        ...pos,
                        type: node.info.nodeType,
                        label: node.info.label,
                        fillComplete: false,
                        content: nodeContentFilter[node.info.name] ? nodeContentFilter[node.info.name](node) : false,
                        taller: false,
                        executionTime: nodeTimeFilter[node.info.name] ? nodeTimeFilter[node.info.name](node) : false,
                        targetCrowd: nodeTargetCrowdFilter[node.info.name] ? nodeTargetCrowdFilter[node.info.name](node) : false,
                        time: '',
                        count: '',
                        // anchorPoints: anchorConfigs[node.info.type - 1], // 设置锚点
                        anchorPoints: [
                            [0, 0.5],
                            [1, 0.5]
                        ] // 设置锚点 存在于节点的左右位置
                    },
                    true
                );
            },

            /**
             * 批量绘制节点和边
             * @param nodes 要绘制的节点
             * @param edges 要画的边
             */
            render({ nodes, edges }, state) {
                resetPos();
                const z = graph.getZoom();
                graph.read({
                    nodes: nodes.map(node => {
                        if (node.info.name === 'CROWD_SPLIT') {
                            // console.log(state[node.id])
                        }
                        let time = '';
                        if (
                            state[node.id] &&
                            state[node.id].state.startTime > 0
                        ) {
                            time = `${Moment(
                                state[node.id].state.startTime
                            ).format('YYYY-MM-DD HH:mm:ss')}`;
                        }
                        return {
                            id: node.id,
                            x: node.x,
                            y: node.y,
                            type: node.info.nodeType,
                            label:
                                typeof node.data?.name === 'string' &&
                                node.data?.name !== ''
                                    ? node.data?.name
                                    : node.info.label,
                            time,
                            count:
                                (node.info.name !== 'CROWD_SPLIT' &&
                                    node.info.name !== 'CROWD_DIFFERENCES' &&
                                    state[node.id]?.variables?.resultNum !=
                                        -1 &&
                                    state[node.id]?.variables?.resultNum) ||
                                '',
                            errorMessage: state[node.id]?.state.errorMsg || '',
                            runState: {
                                success:
                                    !(
                                        typeof state[node.id]?.state
                                            .errorMsg === 'string' &&
                                        state[node.id]?.state.errorMsg !== ''
                                    ) && state[node.id]?.state.endTime > 0,
                                error:
                                    typeof state[node.id]?.state.errorMsg ===
                                        'string' &&
                                    state[node.id]?.state.errorMsg !== '',
                                errorMessage: state[node.id]?.state.errorMsg
                            },
                            fillComplete:
                                node.data.crowdId === '' ? false : true,
                            content: nodeContentFilter[node.info.name] ? nodeContentFilter[node.info.name](node) : false, // 复杂节点上的内容，如短信节点的短信文案、优惠券节点的优惠券信息
                            executionTime: nodeTimeFilter[node.info.name] ? nodeTimeFilter[node.info.name](node) : false, // 复杂节点上的时间信息
                            targetCrowd: nodeTargetCrowdFilter[node.info.name] ? nodeTargetCrowdFilter[node.info.name](node) : false, // 抽取、排除节点的目标人群
                            taller: false, // content里面那些节点，或者任务执行查看详情时，画布上节点需要带着执行时间、内容设置，所以节点高度要设置成高的
                        };
                    }),
                    edges
                });
            },

            /**
             * 有错误的节点设置错误状态
             * @param id 节点id
             * @param state 要设置的状态
             */
            setItemState(id, state, enable) {
                const item = graph.findById(id);
                item.setState(state, enable);
            },

            /**
             * 更新元素的model
             * @param id 元素id
             * @param data model数据
             */
            updateItem(id, data) {
                const item = graph.findById(id);
                item.update(data);
            },

            /**
             * 设置连接校验函数
             * @param validator 校验连接是否可以的函数
             */
            setLinkTargetValidator(validator) {
                linkValidator = validator;
            },
            getClientByPoint(x, y) {
                return graph.getClientByPoint(x, y);
            },
            /**
             * 查询前置节点的id列表（可能有多个前置节点）
             * @param id 要查询的节点的节点id
             */
            getPrevNodeIds,
            /**
             * 查询后置节点的id列表（可能有多个后置节点）
             * @param id 要查询的节点的节点id
             */
            getNextNodeIds,
            zoom, // 画布区域缩放
            addEdge, // 添加边
            undo, // 撤销
            redo, // 恢复
            selectAll, // 全选
            copyNode, // 创建节点副本
            packUpContextMenu, // 取消画布/节点右键事件
            setMode, // 设置画布模式
            getFocusItems, // 获取选中的节点的id列表
            getFocusEdges, // 获取选中的线的元素列表
            changeGraphSize, // 改变画布宽高
            getAllNodeIds, // 获取所有节点的节点id列表
            getAllNodes, // 获取所有节点
            deleteFocusItem, // 将删除焦点内容的方法导出
            getFocusNode, // 获取被选中的节点个数
            getFocusNodes, // 获取被选中的节点信息
            getNodeById, // 根据id获取节点
            resetPos, // 重置画布的位置和zoom
            deleteNodeById, // 根据节点id删除节点
            createComboForCopy, // 复制后生成多选选框
            clearAllStates, // 清除节点及边的状态
            /**
             * 整理
             */
            tidy() {
                const space = 200;
                // 获取画布上的节点列表
                const nodes = graph.getNodes();
                const headNodesIds = nodes
                    .filter(
                        node =>
                            node._cfg.edges.filter(
                                edge => edge._cfg.model.target === node._cfg.id
                            ).length === 0
                    )
                    .map(node => node._cfg.id);

                // 临时数据
                const temp = {};
                // 计算节点的位置，如果有后置节点就发起递归调用
                const calcPos = (id, x, y) => {
                    const nextIds = getNextNodeIds(id);
                    if (id in temp) {
                        temp[id].x = Math.max(temp[id].x, x);
                        // temp[id].y = temp[id].y + space / 2;
                        // temp[id].ys.push(y);
                        temp[id].y = temp[id].ys.reduce((y1, y2) => y1 + y2) / temp[id].ys.length;
                    } else {
                        temp[id] = {
                            id,
                            x,
                            y,
                            ys: [y]
                        };
                    }

                    if (nextIds.length > 0) {
                        nextIds.forEach((nid, index) =>
                            calcPos(
                                nid,
                                temp[id].x + space * 1.5,
                                temp[id].y +
                                    index * space -
                                    ((nextIds.length - 1) * space) / 2
                            )
                        );
                    }
                };

                headNodesIds.forEach((id, index) => {
                    calcPos(id, 100, (index + 1) * 200);
                });

                graph.changeData({
                    nodes: Object.keys(temp).map((id, index) => ({
                        id,
                        // x: 10 + index*10,
                        // y: 10 + index * 10,
                        // ys: [10]
                        ...temp[id]
                    })),
                    // 这里虽然不需要修改变得数据还是得赋值，不然边就丢了，差评！！！
                    edges: graph.getEdges().map(edges => ({
                        // id: edges?._cfg?.id, // 真可恶啊啊啊！升级版本为什么要改变这个嘛
                        source: edges?._cfg?.sourceNode._cfg.id,
                        target: edges?._cfg?.targetNode._cfg.id,
                    }))
                });
                resetPos(); // G6升级到 4.2+版本 后，只要changeData就会失去原点，没办法走个最差的办法，让缩放和原点都‘回到最初的起点，呆呆的站在框框里’
            },
            // 这是一个方法用于页面调试
            test() {
                const node = graph.getNodes()[0];
                // console.log('test -> node', node);
                const group = node.getContainer();
                // console.log('test -> group', group);
                // group.setAttr('opacity', 0.5);
                node.update({
                    style: {
                        opacity: 0.5
                    }
                });
            }
        };
    }
};
